import React from "react";

import { motion } from "framer-motion";

import { jobs } from "./careerData";

import JobCard from "./JobCard";

import AnimatedHeading from "../../animations/AnimatedHeading";

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.18,
    },
  },
};

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 60,
    scale: 0.95,
  },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const OpenPositions = () => {
  return (
    <section
      className="
        relative
        overflow-hidden
        theme-bg-primary
        py-6
        sm:py-8
        lg:py-10
        font-saira
      "
    >
      {/* Background Glow */}
      <motion.div
        animate={{
          scale: [1, 1.15, 1],
          opacity: [0.18, 0.32, 0.18],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        className="
          absolute
          left-1/2
          top-16
          h-[280px]
          w-[280px]
          sm:h-[380px]
          sm:w-[380px]
          lg:h-[500px]
          lg:w-[500px]
          -translate-x-1/2
          rounded-full
          brand-bg
          opacity-10
          blur-[120px]
          lg:blur-[170px]
          pointer-events-none
        "
      />

      <div
        className="
          relative
          z-10
          mx-auto
          max-w-7xl
          px-4
          sm:px-6
          lg:px-8
        "
      >
        {/* Heading */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="
            mx-auto
            mb-10
            max-w-4xl
            text-center
            sm:mb-12
            lg:mb-14
          "
        >
          {/* Label */}
          <motion.p
            variants={itemVariants}
            className="
              brand-color
              text-[11px]
              font-bold
              uppercase
              tracking-[0.28em]
              sm:text-xs
              md:text-sm
            "
          >
            [ Find Opportunity ]
          </motion.p>

          {/* Heading */}
          <motion.div
            variants={itemVariants}
            className="mt-4 sm:mt-5 lg:mt-6"
          >
            <AnimatedHeading
              as="h2"
              parts={["Open Positions"]}
              className="
                text-2xl
                font-semibold
                leading-[1.15]
                tracking-tight
                theme-text-primary
                sm:text-3xl
                md:text-4xl
                lg:text-5xl
                xl:text-6xl
              "
            />
          </motion.div>

          {/* Description */}
          <motion.p
            variants={itemVariants}
            className="
              theme-text-muted
              mx-auto
              mt-5
              max-w-3xl
              text-sm
              leading-7
              sm:mt-6
              sm:text-base
              lg:text-lg
            "
          >
            Discover exciting career opportunities and become part of our
            innovative team, where creativity, collaboration, and technology
            come together to build exceptional digital solutions.
          </motion.p>
        </motion.div>

        {/* Cards */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="
            grid
            grid-cols-1
            gap-5
            sm:gap-6
            md:grid-cols-2
            lg:gap-7
            xl:grid-cols-3
          "
        >
          {jobs.map((job) => (
            <motion.div
              key={job.id}
              variants={itemVariants}
              className="h-full"
            >
              <JobCard job={job} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default OpenPositions;